module.exports = __webpack_public_path__ + "static/media/102-smartphone.e4143c2f.svg";